import {Component, EventEmitter, Input, OnChanges, Output} from '@angular/core';
import {ServerConstants} from '../../../../model/ServerConstants';
import {ValueFromAdditionalMapPipe} from '../../../../pipes/value-from-additional-map.pipe';
import {UtilService} from '../../../../util/util.service';
import {RdapServer, TopLevelDomain} from '@iana-rzms/bff-sdk';
import {ChangeVO} from '../../../../generate/ChangeVO';

@Component({
    selector: 'sub-domain-info-view',
    templateUrl: './sub-domain-info-view.component.html',
    styleUrls: ['./sub-domain-info-view.component.scss'],
    standalone: false
})
export class SubDomainInfoViewComponent implements OnChanges {

  @Input()
  domain: TopLevelDomain;

  @Input()
  showEdit: boolean;

  @Input()
  registryURLChange: ChangeVO;

  @Input()
  whoIsChange: ChangeVO;

  @Input()
  rdapServerChange: ChangeVO;
  @Input()
  viewMode: boolean;
  @Input()
  hasTechnicalPermission: boolean;
  rdapServers: Array<RdapServer> = [];

  registryURL: string;

  whois: string;

  lastchange: string;

  @Output()
  edit = new EventEmitter<boolean>();

  constructor(private util: UtilService) {
  }

  ngOnChanges() {
    if (this.domain != null) {
      this.rdapServers = this.domain.rdapServers;
      this.registryURL = this.getDisplayValue(this.registryURLChange, this.domain.registryUrl);
      this.whois = this.getDisplayValue(this.whoIsChange, this.domain.whois);


      let whoisDate = this.getLastChangeDate(ServerConstants.WHOIS_FIELD_NAME);
      let registryURLDate = this.getLastChangeDate(ServerConstants.REGISTRYURL_FIELD_NAME);
      let rdapServerDate = this.getLastChangeDate(ServerConstants.RDAP_SERVER_FIELD_NAME);

      this.lastchange = this.compareDates(whoisDate, registryURLDate, rdapServerDate);

    }
    if (this.rdapServerChange != null) {
      this.buildRdapServersFromChangeVO();
    }

  }

  onEdit(): void {
    this.edit.emit(true);
  }

  getDisplayValue(change: ChangeVO, value: string): string {
    if (change != null) {
      if (change.operationType === "REMOVE") {
        return change.oldVal.toString();
      }
    }
    return this.util.getDisplayValue(value);
  }



  private buildRdapServersFromChangeVO() {
    this.rdapServers = [];
    this.util.buildObjectFromChange(this.rdapServers, this.rdapServerChange);
  }


  public compareDates(date1: string, date2: string, date3: string): string {

    if (this.util.checkIfEmpty(date1) && this.util.checkIfEmpty(date2) && this.util.checkIfEmpty(date3)) {
      return "";
    }

    let comparedDate = this.compareTwoDates(date1, date2);

    let finalDate = this.compareTwoDates(comparedDate, date3);

    if (finalDate === "") {
      return "";
    }

    return new Date(finalDate).toDateString();
  }

  private compareTwoDates(date1: string, date2: string) {
    if (this.util.checkIfEmpty(date1) && this.util.checkIfEmpty(date2)) {
      return "";
    }

    if (this.util.checkIfEmpty(date1)){
      return date2;
    }

    if (this.util.checkIfEmpty(date2)){
      return date1;
    }

    if (date1 > date2) {
      return date1;
    }

    return date2;
  }

  getLastChangeDate(type: string): string {
    return new ValueFromAdditionalMapPipe().transform(this.domain?.metadata, "lastUpdate", type);
  }

}
